import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import ProductPageImpl from './ProductPageImpl';

import { openDrawer } from './../../../store/slice/MenuSlice';
import { setProductDashboardProductList,setSelectedPharmaorderId } from 'store/slice/PharmaSlice';

export default function ProductPage() {
    const dispatch = useDispatch();
    const {productList} = useSelector((state)=>state.pharmaslice)

    useEffect(() => {
        dispatch(setSelectedPharmaorderId(-1));
        dispatch(openDrawer({drawerOpen: true}));
        // dispatch(setProductDashboardProductList(
        //     productList.filter(productObj => 
        //         !("draft, md approval, accounts approval, refered back".includes(productObj.statusname.toLowerCase()))
        //     ))
        // )


    },[]);

    return (
        < ProductPageImpl />
    )

}